// Domain status/role values stored in Firestore documents.
// These are persisted data contracts — never rename a value without a migration.

export const USER_ROLES = {
  STUDENT: 'student',
  GYM_OWNER: 'gym_owner',
  COACH: 'coach',
  ADMIN: 'admin',
};

export const BOOKING_STATUS = {
  CONFIRMED: 'confirmed',
  REGISTERED: 'registered',
  PENDING_PAYMENT: 'pending_payment',
  CANCELLED: 'cancelled',
};

// A gym doc with no approvalStatus field predates the review flow and is
// treated as approved (grandfathered) — see AuthContext.
export const GYM_APPROVAL_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};
